import { render } from "./ChannelPosts.vue?vue&type=template&id=6b33e053"
import script from "./ChannelPosts.vue?vue&type=script&lang=js"
export * from "./ChannelPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__